import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const CustomerInformationContentStyles = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};
  padding: ${({ theme: { token } }) => token.paddingLG}px;
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;

  .form-header {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    width: 100%;
    color: ${({ theme: { token } }) => token.colorPrimaryText};
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
  }

  .customer-name {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
  }

  .account-id-wrapper {
    display: flex;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    flex: 1;
  }

  .account-id-label {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
  }

  .account-id-value {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .tier-select,
  .account-select {
    width: 100%;
  }

  .tier-form-item,
  .account-form-item {
    margin-bottom: 0;
  }

  .truncated-text {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .address-details-row {
    display: flex;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  .association-text-container {
    flex: 1;
  }

  .association-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    display: block;
  }

  .association-description {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  }

  .icon-avatar {
    background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
    color: ${({ theme: { token } }) => token.colorPrimary};
  }
`;

export const getDrawerStyles = (token: GlobalToken) => ({
  header: {
    paddingBottom: `${token.padding}px`,
    backgroundColor: token.colorBgContainer,
  },
  body: {
    padding: `${token.padding}px ${token.paddingLG}px`,
    backgroundColor: token.colorBgContainer,
  },
  footer: {
    padding: `${token.padding}px ${token.paddingLG}px`,
    borderTop: `1px solid ${token.colorBorderSecondary}`,
    backgroundColor: token.colorBgContainer,
  },
});
